import CookieHandleSelect from './fieldtypes/CookieHandleSelect.vue';

Statamic.$components.register('cookie_cover-fieldtype', CookieHandleSelect);
Statamic.$components.register('cookie_category-fieldtype', CookieHandleSelect);